import styled from '@emotion/styled';
import classNames from 'classnames';

import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import overrideSelectComponents from './override';
import * as S from './styles';

/**
 * Пресет компонентов react-select для асинхронного поиска.
 *
 * Отличия от обычного `override` — те, что нужны именно поиску: подсветка строки под
 * курсором, скролл в длинной выдаче, «Загрузка...» на время запроса и «Нет совпадений»
 * вместо «Список пуст» (список не пуст — просто ничего не нашлось).
 *
 * `SingleValue` здесь намеренно не переопределён: выбранное значение всегда рисует
 * доменный компонент (команда — с логотипом, игрок — ФИО), и передаёт его вызывающая
 * сторона через `components`.
 */

const Option = styled(S.Option)`
  transition: background-color 0.25s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.AccentCornsilk};
  }
`;

export const LoadingMessage = () => {
  return (
    <UDText type="subhead" color={theme.colors.WhiteGray}>
      Загрузка...
    </UDText>
  );
};

const asyncSelectComponents = {
  ...overrideSelectComponents,
  Option: (props: any) => {
    const className = classNames('flex items-center justify-between px-4 w-full', props.isMulti ? 'py-1' : 'py-2');

    return (
      <Option
        {...props.innerProps}
        className={className}
        style={{
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <UDText type="subhead" className="w-full">
          {props.children}
        </UDText>
        {props.isMulti && <S.OptionCheckbox data-checked={props.isSelected} />}
      </Option>
    );
  },
  MenuList: (props: any) => {
    const { cx, ...restProps } = props;
    const { innerProps } = props;
    return (
      <S.MenuList
        {...restProps}
        {...innerProps}
        className="scrollbar-rounded"
        style={{
          maxHeight: '222px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {props.children}
      </S.MenuList>
    );
  },
  NoOptionsMessage: () => {
    return (
      <div className="flex-center flex-col p-8">
        <UDText type="subhead" className="text-surfaceRomanSilver30 mb-2">
          Нет совпадений
        </UDText>
      </div>
    );
  },
};

export default asyncSelectComponents;
